module.exports = __webpack_public_path__ + "static/media/indi_v0.74ba3390.png";